import analytics from '../../analytics'
import {AWS, apigClientFactory} from '../../api'

const defaultCredentials = {
  identityId: '',
  accessKeyId: '',
  secretAccessKey: '',
  sessionToken: '',
  expireTime: ''
}

const defaultApiClient = {}

const apiStore = {
  state: {
    credentials: defaultCredentials,
    apiClient: defaultApiClient
  },
  getters: {
    loggedIn: state => {
      return state.credentials.identityId
    },
    apiClient: state => {
      return state.apiClient
    },
    credentials: state => {
      return state.credentials
    }
  },
  mutations: {
    /**
     * Update Cognito Credentials
     */
    updateCognitoCredentials (state, credentials) {
      state.credentials.identityId = credentials.identityId
      state.credentials.accessKeyId = credentials.accessKeyId
      state.credentials.secretAccessKey = credentials.secretAccessKey
      state.credentials.sessionToken = credentials.sessionToken
      state.credentials.expireTime = credentials.expireTime
    },

    /**
     * Create an API Gateway client once we have AWS Credentials
     */
    createAPIClient (state, additionalConfig) {
      let config = {
        invokeUrl: additionalConfig.apiEndpoint,
        accessKey: state.credentials.accessKeyId,
        secretKey: state.credentials.secretAccessKey,
        sessionToken: state.credentials.sessionToken
      }

      state.apiClient = apigClientFactory.newClient(config)
    },

    /**
     * Reset the API Gateway client when we lose AWS Credentials
     */
    resetAPIClient (state) {
      state.apiClient = defaultApiClient
    }
  },
  actions: {
    /**
     * Get the Cognito Identity Credentials
     */
    getCognitoCredentials: function (context) {
      AWS.config.region = context.getters.awsRegion

      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: context.getters.cognitoIdentityPoolId,
        Logins: context.getters.loginTokens
      })
      console.log('AWS Credentials updated: %O', AWS.config.credentials.params)
      analytics.setUserId(AWS.config.credentials.params.IdentityId)

      var start = analytics.currentTime()
      AWS.config.credentials.get(function (err) {
        var end = analytics.currentTime()
        if (err) {
          analytics.time('API', 'retrieve-credentials', end - start, 'error')
          console.log('Error occurred retrieving credentials: %O', err)

          AWS.config.credentials.clearCachedId()

          context.commit('updateCognitoCredentials', defaultCredentials)
          context.commit('resetAPIClient')
        } else {
          analytics.time('API', 'credentials', end - start, 'success')
          console.log('Successfully retrieved AWS Cognito credentials: %O', AWS.config.credentials)
          // Prepopulate the user profile with the Auth info
          context.commit('updateGivenName', context.getters.authFirstName)
          context.commit('updateSurName', context.getters.authLastName)
          context.commit('updateEmailAddress', context.getters.authEmailAddress)
          // Update the credentials and create the API client
          context.commit('updateCognitoCredentials', AWS.config.credentials)
          context.commit('createAPIClient', {
            apiEndpoint: context.getters.apiGatewayEndpoint
          })
          context.dispatch('onLogin')
        }
      })
    }
  }
}

export default apiStore



// WEBPACK FOOTER //
// ./src/store/api/index.js